import { URL_PREFIX } from '../env'
import { defHttp } from '/@/utils/http/axios'

const SYS_API = {
  GetUserInfo: `${URL_PREFIX}/userProductInfo`,
  GetUserPermission: `${URL_PREFIX}/userAuthorization/getUserResourceV2`,
  GetSuspendedMsg: `${URL_PREFIX}/suspended/message`,
}

/**
 * @description: 获取用户信息
 */
export function getUserInfo(params?: { userId: number; companyId: number }) {
  return defHttp.post(
    {
      url: SYS_API.GetUserInfo,
      params: {
        ...params,
        productApplicationId: '13',
      },
    },
    {
      errorMessageMode: 'none',
    },
  )
}

/**
 * @description: 获取用户权限信息
 */
export function getUserPermission() {
  return defHttp.post(
    { url: SYS_API.GetUserPermission },
    {
      errorMessageMode: 'none',
    },
  )
}

/**
 * @description: 暂停使用期间提示文案
 */
export function getSuspendedMessage() {
  return defHttp.get(
    { url: SYS_API.GetSuspendedMsg },
    {
      errorMessageMode: 'none',
    },
  )
}
